
import { eventsService } from "@/service";
import { defineComponent, reactive } from "vue";

export default defineComponent({
  name: "MyEvents",
  setup() {
    const colors: any = {
      "10": "yellow-status",
      "20": "blue-status",
      "30": "orange-status",
      "40": "green-status",
      "50": "grey-status"
    };
    const state = reactive({
      list: [] as any[],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 20
    });

    const onLoad = async () => {
      if (state.refreshing) {
        state.list = [];
        state.page = 1;
        state.refreshing = false;
      }
      try {
        const { data } = await eventsService.eventLists(state.page, state.pageSize);

        state.list.push(...data.data);

        state.loading = false;
        state.page++;
        if (state.list.length >= data.total) {
          state.finished = true;
        }
      } catch (error) {
        state.finished = true;
        state.loading = false;
      }
    };

    const onRefresh = () => {
      state.finished = false;
      state.loading = true;
      onLoad();
    };

    return {
      state,
      onLoad,
      onRefresh,
      colors
    };
  }
});
